import React, {MouseEvent, useEffect, useState} from 'react';
import { Title } from '../../../../component/title/Title';
import Table from '../../../../component/table/Table.component';
import ButtonBackComponent from '../../../../component/buttton/ButtonBack.component';
import { HEAD_CELL } from './utils/HEAD_CELL';
import GridComponent from '../../../../component/grid/GridComponent.component';
import ButtonComponent from '../../../../component/buttton/Button.component';
import FormFilter from './components/form/FormFilter.component';
import { useManagement } from '../../../../context/Management';
import { getVehiclesQueue } from './VehicleQueueService.component';
import { VehiclesQueueInterface } from './interfaces/VehiclesQueueInterface';
import { INITIAL_PAGINATION } from '../../../../component/table/component/pagination/utils/Pagination';
import { Pagination } from '../../../../component/table/interfaces/Pagination';
import { compare } from '../../../../utils/order/compare';
import Loader from '../../../../component/Loader/LoaderComponent';
import { useSnackbar } from '../../../../context/Snackbar';

const VehicleList = () => {
    const {valueCd} = useManagement();
    const { setSnackbar } = useSnackbar();
    const [buttonFilter, setButtonFilter] = useState(false);
    const [tableVehicles, setTableVehicles] = useState<VehiclesQueueInterface[]>([]);
    const [tableVehiclesAux, setTableVehiclesAux] = useState<VehiclesQueueInterface[]>([]);
    const [pagination, setPagination] = useState<Pagination>(INITIAL_PAGINATION);
    const [loading, setLoading] = useState(Boolean);

    const TableVehiclesQueue = async () => {
        try {
            setLoading(true);
            const {data} = await getVehiclesQueue(`${valueCd}`);
            const table = data.map((item: VehiclesQueueInterface, index: number) => {
                const data = {
                    PosicaoFila: index + 1,
                    Veiculo: item.Veiculo,
                    Tipo: item.Tipo,
                    Data: item.Data,
                    HorarioEntrada: item.HorarioEntrada
                }
                return data
            })
            
            setTableVehicles(table);
            setTableVehiclesAux(table);
            setLoading(false);
            /* console.log(tableVehicles); */
        } catch(error) {
            setLoading(false)
            console.log(error)
            setSnackbar({msg: 'Erro na comunicação com a API.', subMsg: 'Não foi possível mostrar a tabela.', type: 'error'})
        }
    }

    const pageSelect = (tableVehiclesAux: VehiclesQueueInterface[]) => {
        if (pagination.page) {
            return tableVehiclesAux.slice((pagination.page - 1) * 30, pagination.page * 30)
        }
        return tableVehiclesAux;
    }

    const handleChangePage = (_event: unknown, newPage: number) => {
        setPagination({ ...pagination, page: newPage + 1 });
    };

    const handleRequestSort = (_event: MouseEvent<unknown>, property: string) => {
        const isAsc = pagination.sort === property && pagination.order === 1;
        setTableVehiclesAux(tableVehiclesAux.sort((a: any, b: any) => compare(a, b, property, isAsc ? -1 : 1)))
        setPagination({ ...pagination, sort: property, order: isAsc ? -1 : 1 });
    };
    
    const handleSubmitSearch = (vehiclesQueue: VehiclesQueueInterface) => {
        let tableVehiclesQueueSearch: VehiclesQueueInterface[] = [...tableVehicles].filter((el: VehiclesQueueInterface) => {
            let includesVehicles: boolean = !vehiclesQueue.Veiculo || String(el.Veiculo).toLocaleLowerCase().includes(String(vehiclesQueue.Veiculo).toLocaleLowerCase());
            let includesType: boolean = !vehiclesQueue.Tipo || String(el.Tipo).toLocaleLowerCase().includes(String(vehiclesQueue.Tipo).toLocaleLowerCase());
            return includesVehicles && includesType;
        });
        const empty: boolean = !vehiclesQueue.Veiculo && !vehiclesQueue.Tipo;
        setTableVehiclesAux(empty ? [...tableVehicles] : tableVehiclesQueueSearch);
    };

    useEffect(() => {
        TableVehiclesQueue();
    }, [valueCd]);

    return (
        <>
            <ButtonBackComponent to="/gestao-de-patio"/>
            <Title fontSize={30} fontWeigth='900'  margin="0px 0px 20px 0px">Fila de veículos</Title>
            <GridComponent justify="flex-end" alignItems="center" margin='0px 0px 10px 0px'>
                <ButtonComponent onClick={() => setButtonFilter(!buttonFilter)} title='filtro' size='medium' margin='16px 0px 0px 0px' />
            </GridComponent>
            <GridComponent>
                {buttonFilter && <FormFilter handleSubmitForm={handleSubmitSearch} />}
            </GridComponent>
            {loading ? <Loader /> : <Table
                headCells={HEAD_CELL}
                data={pageSelect(tableVehiclesAux)}
                page={pagination.page}
                size={tableVehiclesAux.length}
                onChangePage={handleChangePage}
                order={pagination.order === 1 ? 'asc' : 'desc'}
                orderBy={pagination.sort}
                onRequestSort={handleRequestSort}
            />}
            
        </>
    )
}

export default VehicleList;